import { pinia } from '@/stores'
import { OperationType, useUserStore } from '@/stores/user.store'
import type {
  NavigationGuardNext,
  RouteLocationNormalizedGeneric,
  RouteLocationNormalizedLoadedGeneric
} from 'vue-router'

export function beforeEnter(
  to: RouteLocationNormalizedGeneric,
  from: RouteLocationNormalizedLoadedGeneric,
  next: NavigationGuardNext
) {
  const userStore = useUserStore(pinia)
  const operationType = userStore.decodedToken?.productionSequenceOperation.operation.type

  const isShippingRoute = to.name === 'shipping'
  const isShippingOperation = operationType === OperationType.SHIPPING

  const shouldRedirectToHome =
    (isShippingRoute && !isShippingOperation) || (!isShippingRoute && isShippingOperation)

  if (shouldRedirectToHome) {
    return next({ name: 'home' })
  }

  return next()
}

export default {
  beforeEnter
} as const
